import React from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector, useAppDispatch } from "store/index";
import { handleUpdateFieldTranslation } from "store/emails/slice";
import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";
import TextEditor from "components/wysiwyg/Wysiwyg";

// import styles from "../../../email/NotificationEmailEditModal.module.scss";
import styles from "../../notifications/email/NotificationEmailEditModal.module.scss";
import ModalTabSkeleton from "components/global/Skeleton/ModalTabSkeleton/ModalTabSkeleton";
import { Translation } from "store/gameCenter/types";

export type FieldUpdate<T extends Translation = Translation> = {
  field: keyof T;
  value: T[keyof T];
};

interface Props {
  locales: string[];
  translation: Partial<Translation>;
  activeLocale: string;
  setActiveLocale: (e: string) => void;
  onChange: (v: FieldUpdate) => void;
  isLoaded?: boolean;
  readOnly?: boolean;
}

const LocalTab: React.FC<Props> = ({
  locales,
  translation,
  activeLocale,
  setActiveLocale,
  onChange,
  isLoaded = false,
  readOnly,
}) => {
  const { t } = useTranslation();

  return (
    <div className="game-center-locales">
      <div className={`game-modal-tabs small ${styles["email-tabs"]}`}>
        {locales.map((el) => (
          <div
            className={`tab-item ${activeLocale === el ? "active" : ""}`}
            key={el}
            onClick={() => {
              setActiveLocale(el);
            }}
          >
            <img
              src={`https://flagpedia.net/data/flags/icon/16x12/${el
                .split("-")[1]
                ?.toLowerCase()}.png`}
              alt=""
            />
            {t(el)}
          </div>
        ))}
      </div>

      {!isLoaded ? (
        <ModalTabSkeleton />
      ) : (
        <div className="tournament-rules-form">
          <div className="row" style={{ marginTop: 10 }}>
            <div className="bonus-form-box--item" style={{ flex: 1 }}>
              <InnerInput
                value={translation?.title ?? ""}
                placeholder={t("enterTitle")}
                label={t("title")}
                type="text"
                id="translation-title"
                onChange={(e) => onChange({ field: "title", value: e })}
                disabled={!activeLocale || readOnly}
              />
            </div>

            <div className="bonus-form-box--item">
              <SwitchBtn
                activeTxt={t("active")}
                isActive={!!translation?.isActive}
                handleClick={() =>
                  onChange({
                    field: "isActive",
                    value: translation?.isActive ? false : true,
                  })
                }
                disabled={readOnly}
              />
            </div>
          </div>

          <div className="bonus-form-box--item html-editor">
            <div className="label">{t("content")}</div>
            <TextEditor
              value={translation?.description ?? ""}
              onChange={(v) => onChange({ field: "description", value: v })}
              disabled={!activeLocale || readOnly}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LocalTab;
